import toWebpImage from '@src/utils/to-webp-image';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

const pageLocalesData = getPageLocalesData();
const LocalesData = pageLocalesData.mechaUnit;
const serenithData = LocalesData.baihong;
const lang = getLanguageByPath();

/**
 *  特装机甲数据
 */
export const mechaData = {
  mechaName: toWebpImage(`${require('./images/' + lang + '/warrior-name.png')}`),
  mechaImg: toWebpImage(require('./images/structure.png')),
  driverImg: toWebpImage(require('./images/per.png')),
  iconBadge: toWebpImage(require('./images/icon-badge.png')),
  maLogo: toWebpImage(require('./images/ma-logo.png')),
  btnBack: toWebpImage(require('./images/' + lang + '/btn-back.png')),
  driverStoryTitle: require('./images/' + lang + '/driver-story-title.png'),
  cvTab: [toWebpImage(require('./images/checked1.png')), toWebpImage(require('./images/checked2.png')), toWebpImage(require('./images/checked3.png'))],
  audioScreen: require('./images/audio-screen.png'),
  mechaInfoTitle: require('./images/' + lang + '/mecha-info-title.png'),
  manufacturerTitle: require('./images/' + lang + '/manufacturer-title.png'),
  basicInfoTitle: LocalesData.basicInfoTitle,
  driverVoiceTitle: LocalesData.driverVoiceTitle,
  mechaStorySubTitle: LocalesData.mechaStorySubTitle,
  roleExperSubTitle: serenithData.roleExperSubTitle,
  driverName: serenithData.driverName,
  driverType: serenithData.driverType,
  driversSex: serenithData.driversSex,
  driversBirthplace: serenithData.driversBirthplace,
  driversStructure: serenithData.driversStructure,
  driversRoleExperText: serenithData.driversRoleExperText,
  mechaInfoType: serenithData.mechaInfoType,
  mechaInfoNums: serenithData.mechaInfoNums,
  mechaInfoHeadHigh: serenithData.mechaInfoHeadHigh,
  mechaInfoEmptyWeight: serenithData.mechaInfoEmptyWeight,
  mechaInfoTotal: serenithData.mechaInfoTotal,
  mechaInfoStory: serenithData.mechaInfoStory,
  manufacturerGruopCh: serenithData.manufacturerGruopCh,
  cvCH: serenithData.cvCH,
  cvEN: serenithData.cvEN,
  cvJA: serenithData.cvJA,
  zhCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202508/1754993796613_1-Vox_Pilot_Get_Elite_Genet.wav',
      title: serenithData.voice.title1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202508/1754993796613_2-Vox_Pilot_Entrance_Elite_Genet_a.wav',
      title: serenithData.voice.title2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202508/1754993796613_3-Vox_Pilot_MVP_Elite_Genet_a.wav',
      title: serenithData.voice.title3,
      isPlay: false
    }
  ],
  enCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202508/1754993744277_1-Vox_Pilot_Get_Elite_Genet.wav',
      title: serenithData.voice.title1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202508/1754993744277_2-Vox_Pilot_Entrance_Elite_Genet_a.wav',
      title: serenithData.voice.title2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202508/1754993744277_3-Vox_Pilot_MVP_Elite_Genet_a.wav',
      title: serenithData.voice.title3,
      isPlay: false
    }
  ],
  jaCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202508/1754993774835_1-Vox_Pilot_Get_Elite_Genet.wav',
      title: serenithData.voice.title1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202508/1754993774835_2-Vox_Pilot_Entrance_Elite_Genet_a.wav',
      title: serenithData.voice.title2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202508/1754993774835_3-Vox_Pilot_MVP_Elite_Genet_a.wav',
      title: serenithData.voice.title3,
      isPlay: false
    }
  ]
};
